var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","d":"M0 3v18h24v-18h-24zm21.518 2l-9.518 7.713-9.518-7.713h19.036zm-19.518 14v-11.817l10 8.104 10-8.104v11.817h-20z"}));
}

Email.defaultProps = {"className":"icon","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Email;

Email.default = Email;
